import HeroSlider from "./components/HeroSlider";

export default function Home() {
  return <HeroSlider />;
}